__turbopack_context__.v({
  "actions": "hAQT4G_actions",
  "button": "hAQT4G_button",
  "container": "hAQT4G_container",
  "iconWrap": "hAQT4G_iconWrap",
  "label": "hAQT4G_label",
  "variant--success": "hAQT4G_variant--success",
  "variant--warning": "hAQT4G_variant--warning",
});
